export interface RecallPart {

    part: string;
    partDesc: string;

}
